import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { GuidanceTarget } from "@planard/@core/entities/guidanceTarget";
import { GuidanceService } from "@planard/@core/backend/service/guidance.service";
import { FxRate } from "@planard/@core/entities/fxRate";
import { TranslateService } from "@ngx-translate/core";

@Component({
  templateUrl: "./target-add.component.html",
})
export class TargetAddComponent {
  yearList = [
    new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" })
    ).getFullYear(),
    new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" })
    ).getFullYear() + 1,
    new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" })
    ).getFullYear() + 2,
    new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" })
    ).getFullYear() + 3,
    new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" })
    ).getFullYear() + 4,
    new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" })
    ).getFullYear() + 5,
    new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" })
    ).getFullYear() + 6,
    new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" })
    ).getFullYear() + 7,
    new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" })
    ).getFullYear() + 8,
    new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" })
    ).getFullYear() + 9,
  ];

  target: GuidanceTarget;
  fxRateList: FxRate[];

  form: FormGroup = new FormGroup({
    year: new FormControl("", [Validators.required]),
    salestarget: new FormControl("", [Validators.required]),
    costtarget: new FormControl("", [Validators.required]),
    fxRateId: new FormControl("", [Validators.required]),
  });
  options: FormGroup;
  guidanceId: number;

  constructor(
    public dialogRef: MatDialogRef<TargetAddComponent>,
    public dialog: MatDialog,
    public toastrService: ToastrService,
    public guidanceService: GuidanceService,
    public translate: TranslateService,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.guidanceId = data.guidanceId;
    this.options = fb.group({
      hideRequired: false,
      floatLabel: "auto",
    });
  }

  ngOnInit() {
    this.guidanceService.listAllFxRates().subscribe((result) => {
      this.fxRateList = result;
    });
  }

  save() {
    if (this.form.valid) {
      this.target = this.form.value;
      this.target.guidanceId = this.guidanceId;
      this.guidanceService.addTarget(this.target).subscribe((backendResult) => {
        if (backendResult.isSuccess) {
          this.translate
            .get(`messages.${backendResult.messageId}`)
            .subscribe((data: any) => {
              this.toastrService.success(data);
            });
          this.dialogRef.close(this.target);
        } else {
          this.translate
            .get(`messages.${backendResult.messageId}`)
            .subscribe((data: any) => {
              this.toastrService.error(data);
            });
        }
      });
    } else {
      this.translate.get("common.formNotValid").subscribe((data: any) => {
        this.toastrService.error(data);
      });
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
